export default "__VITE_ASSET__Bk$SfOJU__"